"use strict";

import * as React from 'react';
export const BottomTabBarHeightCallbackContext = /*#__PURE__*/React.createContext(undefined);
//# sourceMappingURL=BottomTabBarHeightCallbackContext.js.map